import {Component, OnInit} from '@angular/core';
import {DialogComponent, DialogService} from "ng2-bootstrap-modal";

export interface AlertModel {
    message: string;
}

@Component({
    selector: 'app-alert-box',
    templateUrl: './alert-box.component.html',
    styleUrls: ['./alert-box.component.css']
})
export class AlertBoxComponent extends DialogComponent<AlertModel, boolean> implements AlertModel {
    message: string;

    constructor(dialogService: DialogService) {
        super(dialogService);
    }

    ngOnInit() {
    }

    cancel() {
        this.result = false;
        this.close();
    }

}



// WEBPACK FOOTER //
// C:/Users/El-Nino/Desktop/coin-alert-test/AngularCoinAlert/src/app/_common/alert-box/alert-box.component.ts